import React, { useState, useEffect,useRef } from 'react'
import NavBar from '../components/NavBar';
import '../../src/App.css';
import { getAssignedTasks, getAssignedTasksStatus } from '../configurations/apiconfig';
import { useNavigate } from 'react-router-dom';

const Dashboard = () =>
{
  const modalRef = useRef(null);

  // const handleSelect = (e) => {
  //   const value = e.target.value;
  //   if (value)
  //   {
  //     console.log(value);
  //     const modal = new window.bootstrap.Modal(modalRef.current);
  //     modal.show();
  //   }
  // };

    const [navbar,setNavigationBar]=useState(true);
    const [data,setData]=useState([]);
    const [taskStatusData,setTaskStatusData]=useState([]);
    const [taskCnt,setTaskCnt]=useState(0);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    useEffect(()=>
    {
        getAssgnedTaskData();
    },[]);

    const handleTaskDetail=()=>
    {
      console.log("chala");
    }

    const getAssgnedTaskData=async()=>
    {
        const res=await getAssignedTasksStatus();
        console.log(res.data["task_assigned"]);
        setData(res.data["task_assigned"]);
        setTaskStatusData(res.data["task_status"]);
        setTaskCnt(res.data["task_assigned"].length);
    }

  return (
    <>
      {navbar==true?<NavBar userType={localStorage.getItem("role_id")}/>:<></>}
              <div class="container dashboard-comp_card py-5">
    {localStorage.getItem("role_id"==3)?    <div class="row g-4">


<div class="col-12 col-sm-6 col-lg-3">
  <div class="card dashboard-card">
    <div class="card-content">
      <div class="card-icon icon-orange">
         <i class="fa fa-folder"></i>
      </div>
      <div class="card-title">Total Projects</div>
      <div class="card-value">1510</div>
      {/* <div class="card-footer">
        <div class="card-meta">updated last week</div>
      </div> */}
    </div>
  </div>
</div>

<div class="col-12 col-sm-6 col-lg-3">
  <div class="card dashboard-card">
    <div class="card-content">
      <div class="card-icon icon-green">
         <i class="fa fa-user"></i>
      </div>
      <div class="card-title">Total Users</div>
      <div class="card-value">15</div>
      {/* <div class="card-footer">
        <div class="card-meta">update 3 days ago</div>
      </div> */}
    </div>
  </div>
</div>

<div class="col-12 col-sm-6 col-lg-3">
  <div class="card dashboard-card">
    <div class="card-content">
      <div class="card-icon icon-red">
         <i class="fa fa-slack"></i>
      </div>
      <div class="card-title">Total Task</div>
      <div class="card-value">75</div>
      {/* <div class="card-footer">
        <div class="card-meta">update 15 hours ago</div>
      </div> */}
    </div>
  </div>
</div>

<div class="col-12 col-sm-6 col-lg-3">
  <div class="card dashboard-card">
    <div class="card-content">
      <div class="card-icon icon-blue">
        <i class="fa fa-check"></i>
      </div>
      <div class="card-title">Total Assigned </div>
      <div class="card-value">+200</div>
      {/* <div class="card-footer">
        <div class="card-meta">updated 2 days ago</div>
      </div> */}
    </div>
  </div>
</div>

</div>:<div class="row g-4">

<div class="col-12 col-sm-6 col-lg-3">
  <div class="card dashboard-card">
    <div class="card-content">
      <div class="card-icon icon-green">
         <i class="fa fa-user"></i>
      </div>
      <div class="card-title">Total Tasks</div>
      <div class="card-value">{taskCnt}</div>
      {/* <div class="card-footer">
        <div class="card-meta">update 3 days ago</div>
      </div> */}
    </div>
  </div>
</div>
{/* 
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">Hello from dropdown!</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div> */}

<div className="col-md-12">
  <div className="card p-3">
    <h4 className="mb-1">Assigned Task</h4>
    {/* <ToastContainer /> */}
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle fs-6">
        <thead>
          <tr>
            <th>id</th>
            <th>Title</th>
            <th>Desctiption</th>
            <th>Task Description</th>
            <th>Time Line</th>
            <th>Assigned To</th>
            <th>Assigned By</th>
            <th>Status</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
        {data.map((currentElement)=>
    {
        const cnt=0;
        return(<tr key={currentElement.id}>
            <td>{currentElement.id}</td>
            <td>{currentElement.title}</td>
            <td>{currentElement.description}</td>
            <td>{currentElement.task_description}</td>
            <td>{currentElement.time_line}</td>
            <td>{currentElement.assigned_to}</td>
            <td>{currentElement.assigned_by}</td>
            <td>{currentElement.status}</td>
            <td>
            {/* <select className="form-select" name="status" id="status" onChange={handleSelect}> */}
            <select className="form-select" name="status" id="status" disabled>
            
              <option selected disabled>Status</option>
              {taskStatusData.map((currentEle=>
              {
                return(<option selected={currentElement.status==currentEle.id?true:false} value={currentEle.id} key={currentEle.id}>{currentEle.title}</option>)
              }))}

            </select>
            </td>
            <td>
              <button className="btn btn-primary m-1"><i class="bi bi-arrow-up-right-square-fill" onClick={()=>{navigate('/taskHandlingManagement', { state: { ta_id: currentElement } });}}></i></button>
          </td>
          </tr>)
    })}
        </tbody>

      </table>
    </div>
  </div>
</div>


</div>}
  </div>
  </>
  )
}

export default Dashboard
